var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon-svg",style:({
    fill: _vm.fill,
  }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }